import CircularProgress from '@mui/material/CircularProgress';
import { PropsWithChildren } from 'react';
import FlexBox, { FlexBoxProps } from '../layout/FlexBox';

export type SelectableCardProps = FlexBoxProps & {
  uploadProgress?: number;
  selected?: boolean;
  isLoading?: boolean;
  hasError?: boolean;
  onAbort?: () => void;
};

const SelectableCard: React.FC<PropsWithChildren<SelectableCardProps>> = ({
  uploadProgress,
  selected,
  isLoading,
  hasError,
  onAbort,
  onClick,
  children,
  ...props
}) => (
  <FlexBox
    onClick={!isLoading ? onClick : undefined}
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap={0.5}
    p={2}
    position="relative"
    overflow="hidden"
    border={selected || hasError ? '2px solid' : '1px solid'}
    borderColor={hasError ? 'red.400' : selected ? 'blue.400' : 'gray.300'}
    borderRadius={2}
    bgcolor={selected ? 'blue.50' : 'common.white'}
    cursor={'pointer'}
    userSelect={'none'}
    {...props}
  >
    {children}
    {isLoading && (
      <FlexBox
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        bgcolor="rgba(255, 255, 255, 0.6)"
      >
        <CircularProgress
          size={32}
          variant={uploadProgress ? 'determinate' : 'indeterminate'}
          value={uploadProgress}
          onClick={onAbort}
          sx={onAbort ? { cursor: 'pointer' } : undefined}
        />
      </FlexBox>
    )}
  </FlexBox>
);

export default SelectableCard;
